<div class="px-2">
  <!-- class="border-b border-border p-2" -->
  <div class="border-b border-border flex flex-row justify-between py-2">
    <div>
      <div class="flex flex-col">
        <span class="font-semibold text-sm">{{
          shoppingItem.product.name
        }}</span>

        <div class="flex flex-row">
          <span class="font-light text-xs mr-4"
            >SKU: {{ shoppingItem.product.sku }}
          </span>
          <span class="font-light text-xs mr-1">Categorías: </span>
          @for(category of shoppingItem.product.product_categories; track category.id) {
          <span class="font-light text-xs mr-2">{{ category.name }}</span>
          }
        </div>
      </div>

      <span class="text-sm"
        >Precio por rollo:
        {{ shoppingItem.product.price_roll | currency }}</span
      >

      <div class="mt-1 flex flex-row items-center gap-1">
        <span class="text-sm">Colores:</span>
        <!--  -->
        @for(availableColor of availableColors; track availableColor.color) {
        <button
          type="button"
          (click)="setColor(availableColor.color, true)"
          class="rounded-full"
          [class.active]="selectedColor === availableColor.color"
          [title]="availableColor.color"
        >
          <app-color-total
            [color]="availableColor.color"
            [total]="availableColor.roll_count"
          ></app-color-total>
        </button>
        }
        <!-- class="rounded-full w-4 h-4 flex justify-center items-center leading-0" -->
        <!-- [class]="getColorClass(color)" -->
      </div>

      <!-- @if(color) { -->
      <div class="mt-1 flex flex-row gap-2 items-center">
        <span class="text-sm">Ancho:</span>
        <!--  -->
        @for(width of shoppingItem.product.possible_widths ; track width) {
        <button
          type="button"
          class="rounded-full border h-5 px-2 flex justify-center items-center leading-0 text-xs"
          [class.active]="selectedWidth == width"
          [disabled]="!isWidthEnabled(width)"
          (click)="setWidth(width, true)"
        >
          {{ width }}
        </button>
        }
      </div>

      <!-- <span class="text-sm text-muted-foreground"
        >Rollos disponibles: {{ roll_count }}</span
      > -->

      <p class="text-sm text-muted-foreground">
        Almacenes disponibles:
        <!--  -->
        @for(warehouse of availableWarehouses; track warehouse.warehouse) {
        <span class="inline-block mr-1">{{ warehouse.warehouse }}: </span
        ><span class="inline-block mr-1">{{ warehouse.roll_count }}</span>
        }
      </p>
    </div>

    <div class="w-fit flex flex-col align-middle gap-2">
      <div class="flex flex-row">
        <button
          type="button"
          class="secondary normal"
          (click)="takeUnit()"
          [disabled]="!(selectedColor && selectedWidth)"
        >
          -
        </button>

        <input
          type="number"
          class="basic-input w-20"
          [(ngModel)]="quantity"
          (keyup)="changeUnits()"
          [disabled]="!(selectedColor && selectedWidth)"
        />

        <button
          type="button"
          class="primary normal"
          (click)="addUnit()"
          [disabled]="!(selectedColor && selectedWidth)"
        >
          +
        </button>
      </div>

      <button
        type="button"
        class="destructive normal"
        (click)="deleteShoppingItem()"
      >
        Eliminar
      </button>
    </div>
  </div>
</div>
